import axios from '@/utils/request'

// 获取上传证书
export const documentGetUploadPolicy = (params = {}) => axios.get('/openpms/document/upload/policy/get', { params }).then(res => res.data)

// 添加文件
export const documentAdd = (params = {}) => axios.post('/openpms/document/add', params).then(res => res.data)
